module.exports = __webpack_public_path__ + "img/myadt-logo.9b9de3c6.svg";